import { render, staticRenderFns } from "./sort-score.vue?vue&type=template&id=256a4d4a&scoped=true&"
import script from "./sort-score.vue?vue&type=script&lang=js&"
export * from "./sort-score.vue?vue&type=script&lang=js&"
import style0 from "./sort-score.vue?vue&type=style&index=0&id=256a4d4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256a4d4a",
  null
  
)

export default component.exports